import { render, staticRenderFns } from "./PerfilList.vue?vue&type=template&id=bbae56b0&scoped=true&"
import script from "./PerfilList.vue?vue&type=script&lang=js&"
export * from "./PerfilList.vue?vue&type=script&lang=js&"
import style0 from "./PerfilList.vue?vue&type=style&index=0&id=bbae56b0&lang=scss&scoped=true&"
import style1 from "./PerfilList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbae56b0",
  null
  
)

export default component.exports